
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';

// Styled Components
const AboutContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
`;

const HeroSection = styled.section`
  position: relative;
  height: 60vh;
  min-height: 400px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const HeroBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;

const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(30, 58, 138, 0.7);
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
  max-width: 800px;
  padding: 0 2rem;
`;



const ContentSection = styled.section`
  padding: 6rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 4rem;
  margin-bottom: 6rem;
`;

const StoryCard = styled(motion.div)`
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: linear-gradient(90deg, #f59e0b, #d97706);
  }
`;

const CardTitle = styled.h3`
  font-size: 2rem;
  color: #1e3a8a;
  margin-bottom: 1.5rem;
`;

const CardText = styled.p`
  color: #4b5563;
  line-height: 1.8;
  margin-bottom: 1.5rem;
`;

const HighlightText = styled.span`
  color: #f59e0b;
  font-weight: 600;
`;

const ValuesSection = styled.section`
  padding: 6rem 2rem;
  background: white;
`;

const ValuesContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
`;

const ValueCard = styled(motion.div)`
  text-align: center;
  padding: 2rem;
  border-radius: 15px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const ValueIcon = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
`;

const ValueTitle = styled.h4`
  font-size: 1.5rem;
  color: #1e3a8a;
  margin-bottom: 1rem;
`;

const ValueDescription = styled.p`
  color: #6b7280;
  line-height: 1.6;
`;

// const StatsSection = styled.section`
//   padding: 6rem 2rem;
//   background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
//   color: white;
// `;

// const StatsContainer = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
// `;

// const StatsGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 3rem;
//   text-align: center;
// `;

// const StatCard = styled(motion.div)`
//   padding: 2rem;
// `;

// const StatNumber = styled.div`
//   font-size: 3rem;
//   font-weight: 700;
//   margin-bottom: 1rem;
//   color: #f59e0b;
// `;

// const StatLabel = styled.div`
//   font-size: 1.2rem;
//   opacity: 0.9;
// `;

// const TeamSection = styled.section`
//   padding: 6rem 2rem;
//   background: #f8fafc;
// `;

// const TeamContainer = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
// `;

const SectionTitle = styled(motion.h2)`
  font-size: clamp(2rem, 4vw, 3rem);
  text-align: center;
  color: #1e3a8a;
  margin-bottom: 1rem;
`;

// const SectionSubtitle = styled(motion.p)`
//   text-align: center;
//   color: #6b7280;
//   font-size: 1.2rem;
//   margin-bottom: 4rem;
//   max-width: 600px;
//   margin-left: auto;
//   margin-right: auto;
// `;

// const TeamGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//   gap: 3rem;
// `;

// const TeamMember = styled(motion.div)`
//   background: white;
//   border-radius: 15px;
//   overflow: hidden;
//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//   transition: transform 0.3s ease;
  
//   &:hover {
//     transform: translateY(-10px);
//   }
// `;

// const MemberImage = styled.div`
//   height: 300px;
//   background-image: url(${props => props.src});
//   background-size: cover;
//   background-position: center;
// `;

// const MemberInfo = styled.div`
//   padding: 2rem;
// `;

// const MemberName = styled.h4`
//   font-size: 1.5rem;
//   color: #1e3a8a;
//   margin-bottom: 0.5rem;
// `;

// const MemberRole = styled.p`
//   color: #f59e0b;
//   font-weight: 600;
//   margin-bottom: 1rem;
// `;

// const MemberBio = styled.p`
//   color: #6b7280;
//   line-height: 1.6;
// `;

const AnimatedSection = ({ children }) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
    >
      {children}
    </motion.div>
  );
};

const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  };

  return (
    <AboutContainer>
      {/* Hero Section */}
      <HeroSection>
        <HeroBackground />
        <HeroOverlay />
        <HeroContent>
          <motion.h1
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            Our Story
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            Discover the legacy of Wular Lake Resort, where luxury meets nature in perfect harmony
          </motion.p>
        </HeroContent>
      </HeroSection>

      {/* Story Section */}
      <ContentSection>
        <AnimatedSection>
          <SectionTitle>Our Journey</SectionTitle>
        </AnimatedSection>
        
        <SectionGrid>
          <StoryCard
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <CardTitle>Founded in Heritage</CardTitle>
            <CardText>
             Wular Water Front Resort was born from a vision to create a sanctuary where guests could experience the pristine beauty of Kashmir's crown jewel while enjoying world-class hospitality.
            </CardText>
            <CardText>
              Our founders,  transformed a modest lakeside property into the luxurious retreat it is today, always staying true to their commitment to preserving the natural environment.
            </CardText>
          </StoryCard>

          <StoryCard
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <CardTitle>Nature's Paradise</CardTitle>
            <CardText>
              Situated on the shores of <HighlightText>Asia's largest freshwater lake</HighlightText>, our resort offers breathtaking views of the Himalayas and direct access to the crystal-clear waters of Wular Lake.
            </CardText>
            <CardText>
              We've carefully designed our facilities to complement the natural landscape, ensuring that every guest can experience the magic of this unique ecosystem while enjoying modern comforts.
            </CardText>
          </StoryCard>
        </SectionGrid>
      </ContentSection>

      {/* Values Section */}
      <ValuesSection>
        <ValuesContainer>
          <AnimatedSection>
            <SectionTitle style={{ color: 'white', marginBottom: '3rem' }}>Our Values</SectionTitle>
          </AnimatedSection>
          
          <ValuesGrid
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              {
                icon: '🌿',
                title: 'Sustainability',
                description: 'We are committed to preserving Wular Lake\'s ecosystem through eco-friendly practices and conservation efforts.'
              },
              {
                icon: '🏆',
                title: 'Excellence',
                description: 'From our world-class amenities to personalized service, excellence is at the heart of everything we do.'
              },
              {
                icon: '🤝',
                title: 'Hospitality',
                description: 'Kashmiri hospitality runs deep in our veins. Every guest is treated like family, with warmth and respect.'
              },
              {
                icon: '💎',
                title: 'Integrity',
                description: 'We operate with transparency and honesty, building trust with our guests, staff, and community.'
              }
            ].map((value, index) => (
              <ValueCard
                key={index}
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
              >
                <ValueIcon>{value.icon}</ValueIcon>
                <ValueTitle>{value.title}</ValueTitle>
                <ValueDescription>{value.description}</ValueDescription>
              </ValueCard>
            ))}
          </ValuesGrid>
        </ValuesContainer>
      </ValuesSection>

      {/* Stats Section */}
      {/* <StatsSection>
        <StatsContainer>
          <AnimatedSection>
            <SectionTitle style={{ color: 'white', marginBottom: '3rem' }}>By the Numbers</SectionTitle>
          </AnimatedSection>
          
          <StatsGrid
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              { number: '38+', label: 'Years of Excellence' },
              { number: '50+', label: 'Luxury Rooms' },
              { number: '15,000+', label: 'Happy Guests' },
              { number: '24/7', label: 'Premium Service' }
            ].map((stat, index) => (
              <StatCard
                key={index}
                variants={itemVariants}
              >
                <StatNumber>{stat.number}</StatNumber>
                <StatLabel>{stat.label}</StatLabel>
              </StatCard>
            ))}
          </StatsGrid>
        </StatsContainer>
      </StatsSection> */}

      {/* Team Section */}
      {/* <TeamSection>
        <TeamContainer>
          <AnimatedSection>
            <SectionTitle>Meet Our Team</SectionTitle>
            <SectionSubtitle>
              The passionate individuals who make your stay unforgettable
            </SectionSubtitle>
          </AnimatedSection>
          
          <TeamGrid
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              {
                name: 'Ahmed Abdullah',
                role: 'General Manager',
                bio: 'With over 20 years of hospitality experience, Ahmed ensures every guest experiences the true essence of Kashmiri hospitality.',
                image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=300&q=80'
              },
              {
                name: 'Sara Khan',
                role: 'Head of Operations',
                bio: 'Sara\'s attention to detail and commitment to excellence ensures smooth operations and exceptional guest experiences.',
                image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=300&q=80'
              },
              {
                name: 'Rajesh Kumar',
                role: 'Executive Chef',
                bio: 'Chef Rajesh brings culinary expertise from around the world, creating unforgettable dining experiences with local ingredients.',
                image: 'https://images.unsplash.com/photo-1580489949142-65291d1e0822?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=300&q=80'
              }
            ].map((member, index) => (
              <TeamMember
                key={index}
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
              >
                <MemberImage src={member.image} />
                <MemberInfo>
                  <MemberName>{member.name}</MemberName>
                  <MemberRole>{member.role}</MemberRole>
                  <MemberBio>{member.bio}</MemberBio>
                </MemberInfo>
              </TeamMember>
            ))}
          </TeamGrid>
        </TeamContainer>
      </TeamSection> */}
    </AboutContainer>
  );
};

export default About;
